import { MENU_KEY_ROUTES } from "src/constants/modules";
import { HotelSearch, HotelsListing, HotelBooking } from "src/Modules/Hotels";
import HotelDetails from "src/Modules/Hotels/Pages/HotelDetails/HotelDetails";
import HotelBookingResult from "src/Modules/Hotels/Pages/HotelBookingResult/HotelBookingResult";
import HotelsWrapper from "src/Modules/Hotels/HotelsWrapper";


export const hotelRoutes = {
  path: MENU_KEY_ROUTES["Hotel"],
  element: <HotelsWrapper />,
  children: [
    {
      index: true,
      element: <HotelSearch />,
    },
    {
      path: ":searchId",
      children: [
        {
          index: true,
          element: <HotelsListing />,
        },
        {
          path: "hotel/:hotelKey",
          element: <HotelBooking />,
        },
        {
          path:"hotel/:hotelKey/book/:hotelDetailsKey/:step?",
          element:<HotelDetails/>
        },
      ],
    },
    {
      path:"booking-result/:hotelDetailsKey",
      element:<HotelBookingResult />,
    }
  ],
};
